<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="5"
            categoryName="Choke / Gauge"
            categorySectionIcon="fa-bolt"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'choke',
    components: { BaseInventory }
}
</script>
